import { render, staticRenderFns } from "./RtRouteList.vue?vue&type=template&id=f667fa36&"
import script from "./RtRouteList.vue?vue&type=script&lang=js&"
export * from "./RtRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports